import axios from 'axios';
import { strapiApiUrl } from './constants';
import { devError } from './devLog';

export const axiosGet = async (urlParameters, configParameters = {}) => {
  try {
    return await axios.get(`${strapiApiUrl}${urlParameters}`, {
      params: configParameters,
      withCredentials: true,
    });
  } catch (error) {
    devError('axiosGet failed:', error);
  }
};
